import { DetailsCard } from "@/routes/app/-components/details-card"
import { LabeledValue } from "@components/default-list/labeled-value"
import { DefaultListItem } from "@components/default-list/list-item"
import { useTranslation } from "react-i18next"
import { Text } from "@mantine/core"
import { getFormattedDate } from "@/utils/get-formatted-date"
import { ContractDateDto } from "@/@client/Theasoft_ApiServer_Contracts"
import { useBatchedActivityType } from "@/-dataloaders/activity-types"

interface Props {
  data: { productionTitle: string; contractDates: ContractDateDto[] }[]
}

export function ContractDatesCard({ data }: Props) {
  const { t } = useTranslation("app_server")
  if (data.flatMap((v) => v.contractDates).length === 0) return null

  return (
    <DetailsCard title={t("Appointments")}>
      {data
        .filter((v) => v.contractDates.length > 0)
        .map((v, i) => (
          <React.Fragment key={i}>
            <Text fz={"lg"} fw={"bold"}>
              {v.productionTitle}
            </Text>
            {v.contractDates.map((cd, i) => (
              <ContractDate key={i} contractDate={cd} />
            ))}
          </React.Fragment>
        ))}
    </DetailsCard>
  )
}

function ContractDate({ contractDate }: { contractDate: ContractDateDto }) {
  const { t } = useTranslation("app_server")
  const { data: activityType } = useBatchedActivityType(
    contractDate.activityTypeId || undefined
  )

  const Label = React.memo(() => (
    <Text>
      {activityType?.name && activityType?.name}
      {contractDate.activityTypeId && contractDate.isMaturityDate && " "}
      {contractDate.isMaturityDate && t("Maturity")}
      {contractDate.isMaturityDate && contractDate.maturity?.description && " "}
      {contractDate.maturity?.description}
    </Text>
  ))

  const Value = React.memo(() => (
    <Text>
      {getFormattedDate(
        contractDate.start,
        contractDate.activityTypeId ? "L LT" : "L"
      )}
      {contractDate.maturity?.amount && ` ${contractDate.maturity.amount}`}
    </Text>
  ))

  return (
    <DefaultListItem>
      <LabeledValue
        label={<Label />}
        value={<Value />}
        description={contractDate.description}
      />
    </DefaultListItem>
  )
}
